module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-module mb"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "hotSale clearfix"
  }, _vm._l((_vm.hotPersonalStoreList), function(store, index) {
    return (index < 4) ? _c('div', {
      key: store.storeId,
      staticClass: "hotSale-item"
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/shop',
          query: {
            tab: 1,
            store_id: store.storeId
          }
        },
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "hotSale-item-img",
      attrs: {
        "src": store.storeBanner,
        "alt": store.storeName
      }
    })]), _vm._v(" "), _c('router-link', {
      staticClass: "hotSale-info",
      attrs: {
        "to": {
          path: '/shop',
          query: {
            tab: 1,
            store_id: store.storeId
          }
        },
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": store.storeLogo,
        "width": "100",
        "height": "50"
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "hotSale-name"
    }, [_c('span', {
      staticClass: "hotSale-store"
    }, [_vm._v(_vm._s(store.storeName))]), _vm._v(" "), _c('span', {
      staticClass: "hotSale-rate"
    }, [_vm._v("好评率：" + _vm._s(store.praiseRate * 100) + "%")])])]), _vm._v(" "), _c('div', {
      staticClass: "hotSale-hover"
    }, [_c('div', {
      staticClass: "hotSale-pro-list clearfix"
    }, _vm._l((_vm.hotPersonalStoreGoodList), function(goods) {
      return (goods.storeId == store.storeId) ? _c('router-link', {
        key: goods.goodsId,
        staticClass: "hotSale-hover-pro",
        attrs: {
          "to": {
            path: '/goods',
            query: {
              goods_id: goods.goodsId
            }
          },
          "target": "_blank"
        }
      }, [_c('img', {
        staticStyle: {
          "cursor": "pointer"
        },
        attrs: {
          "src": goods.design_image || goods.designImage,
          "width": "140px",
          "height": "177px",
          "alt": store.storeName
        }
      }), _vm._v(" "), _c('span', [_vm._v("￥ " + _vm._s(goods.price))])]) : _vm._e()
    }), 1), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": {
          path: '/shop',
          query: {
            tab: 1,
            store_id: store.storeId
          }
        },
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "hotSale-hover-logo",
      attrs: {
        "src": store.storeLogo,
        "width": "100",
        "height": "50",
        "alt": store.storeName
      }
    })]), _vm._v(" "), _c('a', {
      staticClass: "hotSale-favorite",
      attrs: {
        "href": "javascript:void(0);",
        "onclick": "collect_store(${hotPersonalStore.storeId},this,'store_collect');"
      }
    }, [_vm._v("收藏本店")]), _vm._v(" "), _c('router-link', {
      staticClass: "enter-btn",
      attrs: {
        "to": {
          path: '/shop',
          query: {
            tab: 1,
            store_id: store.storeId
          }
        },
        "target": "_blank"
      }
    }, [_vm._v("\n\t\t\t\t\t    进入店铺\n\t\t\t\t\t")])], 1), _vm._v(" "), _c('span', {
      staticClass: "jpStore"
    })], 1) : _vm._e()
  }), 0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "module-title"
  }, [_c('span', [_vm._v("人气热推")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-de016424"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/personal-shop/popular-hot.vue
// module id = 1671
// module chunks = 1